const state = {
  components: [],
};

const cacheState = () => {
  const sections = Array.from(document.querySelectorAll('[data-section="hub-fit"]'));
  state.components = sections.reduce((components, section) => {
    const currentComponent = {
      id: section.dataset.overlayId,
      hotspots: section.querySelectorAll('[data-fit-viewer-hotspot]'),
      titles: section.querySelectorAll('[data-fit-viewer-title]'),
    };
    return [...components, currentComponent];
  }, []);
};

const setActive = (parent, index) => {
  const activeIndex = Array.from(parent)?.findIndex((child) => child.classList.contains("active"));

  parent[activeIndex]?.classList.remove("active");
  (activeIndex !== index) && parent[index]?.classList.add("active");
};

const addEventListeners = () => {
  state.components.forEach((component) => {
    const { hotspots, titles } = component;
    hotspots?.forEach((hotspot, index) => {
      hotspot?.addEventListener('click', () => {
        setActive(hotspots, index);
        setActive(titles, index);
      });
    });
  });
};

const init = () => {
  cacheState();
  addEventListeners();
};

export default init;
